// useDocumentTypeTree — fetches and caches the document type tree.
// Stale time: 1 hour (tree changes only on admin config updates).
//
// F11 (Task 118): Initial implementation.

import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../api/queryKeys';
import { getDocumentTypeTree } from '../../api/endpoints/documentTypes';
import type { DocumentTypeTreeResponse } from '../../api/generated/schema';

function useDocumentTypeTree() {
  return useQuery<DocumentTypeTreeResponse>({
    queryKey: queryKeys.documentTypes.tree(),
    queryFn: getDocumentTypeTree,
    staleTime: 60 * 60 * 1000, // 1 hour
  });
}

export default useDocumentTypeTree;
